import type { LucideIcon } from "lucide-react";
import { CreditCard, Monitor, User } from "lucide-react";

export type AccountNavItem = {
  href: string;
  label: string;
  icon: LucideIcon;
};

export const ACCOUNT_NAV_ITEMS: AccountNavItem[] = [
  { href: "/settings/account", label: "Account", icon: User },
  { href: "/settings/sessions", label: "Sessions", icon: Monitor },
  { href: "/billing", label: "Billing", icon: CreditCard },
];

export const WORKSPACE_HOME_HREF = "/home";
